import { render, staticRenderFns } from "./TransactionType.vue?vue&type=template&id=09f06776&scoped=true&"
import script from "./TransactionType.vue?vue&type=script&lang=js&"
export * from "./TransactionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f06776",
  null
  
)

export default component.exports